export default __webpack_public_path__ + "static/media/OSBplader.020a085d.svg";